module.exports = __webpack_public_path__ + "static/media/armadillo-booking-1.6b681deb.jpg";